// extracted by mini-css-extract-plugin
module.exports = {"container_dropdown":"container_dropdown-vZNsT","segment__card":"segment__card-1d9p1","time":"time-3Dnez"};